"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_quill_1 = require("react-quill");
var BlockEmbed = react_quill_1.Quill.import("blots/block/embed");
var VideoBlot = /** @class */ (function (_super) {
    __extends(VideoBlot, _super);
    function VideoBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoBlot.create = function (value) {
        var node = _super.create.call(this);
        node.setAttribute("src", value.url);
        node.setAttribute("controls", "controls");
        // node.setAttribute('preload', 'none');
        node.setAttribute("width", 480);
        node.setAttribute("height", 270);
        return node;
    };
    VideoBlot.value = function (node) {
        return {
            url: node.getAttribute("src"),
            // width: node.getAttribute('width'),
            // height: node.getAttribute('height')
        };
    };
    return VideoBlot;
}(BlockEmbed));
VideoBlot.blotName = "html5Video";
VideoBlot.tagName = "video";
react_quill_1.Quill.register("formats/html5Video", VideoBlot);
